import { Component, Input } from 'angular-ts-decorators';

import template from './product-item-sku.component.html';

@Component({
  selector: 'productItemSku',
  template,
})
export class ProductItemSkuComponent {
  public static $inject: ReadonlyArray<string> = [];

  @Input() public sku: string;
}
